import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { CampaignSelector } from './CampaignSelector';
const formatCurrency = (value: number) => value.toLocaleString('en-US');
export function EdgePricing() {
  const [campaignMode, setCampaignMode] = useState(1);
  const isPartial = campaignMode === 0;
  const campaigns = isPartial ? 1 : campaignMode;
  const buildFee = 4000 + Math.max(0, campaignMode - 1) * 500;
  const systemFee = 1500;
  const campaignFee = 750 * (campaignMode + 1);
  const monthlyTotal = systemFee + campaignFee;
  return <section className="pt-4 pb-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-63" data-mp="3098m7ehgh3da">
      <CampaignSelector mode={campaignMode} onChange={setCampaignMode} accent="slate" data-id="element-64" data-mp="3570bs1umodeb" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-65" data-mp="3a8ppxqd5d76m">
        <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-66" data-mp="kim31vauebfw">
          <div className="mb-4" data-id="element-67" data-mp="pg4cdmsrusof">
            <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-68" data-mp="pf2scsts2vuk">
              Build and Implementation (One-Time)
            </div>
            <div className="text-3xl font-bold text-white" data-id="element-69" data-mp="mbt4fpmjzz1p">
              ${formatCurrency(buildFee)}
            </div>
            <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-70" data-mp="hc6lczk1nokz">
              {['Company and opportunity profiling', 'Custom ATS, workflows, and job board integrations', 'Landing page and candidate application flow', 'Campaign messaging and ad creative', 'Pre-launch system setup and stress test', 'Access to HIRE’s LMS best-practices library', 'Interview process training', 'Five Sales School tickets'].map(point => <li key={point} className="flex items-start" data-id="element-71" data-mp="3ku83q2n50hpe">
                  <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-72" data-mp="3kvt07xt0iapw" />
                  <span className="text-slate-400 text-sm leading-snug" data-id="element-73" data-mp="3fwyeamzr061k">
                    {point}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="bg-slate-900/40 border border-slate-600 p-6 rounded-xl relative" data-id="element-74" data-mp="3b3ztiybtmoxo">
          <div className="absolute top-0 left-0 w-full h-1 bg-slate-500 rounded-t-xl" data-id="element-75" data-mp="2x8o0qwh878je" />
          <div className="mb-4" data-id="element-76" data-mp="318g9b96mdeor">
            <div className="text-xs text-slate-400 uppercase tracking-widest mb-2" data-id="element-77" data-mp="3oy0ulyq8wo17">
              Total Monthly
            </div>
            <div className="text-4xl font-bold text-white mb-1" data-id="element-78" data-mp="3tvskyob8s23a">
              ${formatCurrency(monthlyTotal)}
            </div>
            <div className="text-sm text-slate-500 mb-6" data-id="element-79" data-mp="3g56zqsybfg28">/ month</div>

            <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-80" data-mp="3k5zajqmu5t0m">
              <div className="flex justify-between text-sm" data-id="element-81" data-mp="brh5lxs6ytl8">
                <span className="text-slate-400" data-id="element-82" data-mp="bp4gn0o0niyo">Catalyst ATS</span>
                <span className="text-white font-medium" data-id="element-83" data-mp="giqx73xaw6zr">
                  ${formatCurrency(systemFee)}
                </span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-84" data-mp="21604p5zpkgv5">
                <span className="text-slate-400" data-id="element-85" data-mp="1w8qevp8eq36s">Campaign Management</span>
                <span className="text-white font-medium" data-id="element-86" data-mp="2ayfma273f3fi">
                  ${formatCurrency(campaignFee)}
                </span>
              </div>
            </div>

            <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-87" data-mp="1i9ifowc8uv2l">
              {['Active job board management and campaign optimization', 'Applicant screening and pre-qualification', 'Candidate handoff to your internal team', 'Multi-market coordination and reporting', 'Ongoing system support and performance visibility'].map(point => <li key={point} className="flex items-start" data-id="element-88" data-mp="33la0wih8b8l2">
                  <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-89" data-mp="2yo9wsd3xwfwl" />
                  <span className="text-slate-400 text-sm leading-snug" data-id="element-90" data-mp="186wh6f7jk44g">
                    {point}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-91" data-mp="1h6td91w9g59j">
          <div className="mb-4" data-id="element-92" data-mp="1m6edrgr2wlod">
            <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-4" data-id="element-93" data-mp="1m6o10wkqoeqd">
              Sales School Tickets
            </div>
            <div className="flex items-baseline mb-2" data-id="element-94" data-mp="1r58umd5hk05u">
              <span className="text-3xl font-bold text-white" data-id="element-95" data-mp="1w3sem80ir1vk">$200</span>
              <span className="text-slate-400 ml-2 text-sm" data-id="element-96" data-mp="20vaknahefsne">per ticket</span>
            </div>
            <p className="mt-5 pt-4 border-t border-slate-800/50 text-slate-400 text-sm leading-snug" data-id="element-97" data-mp="24ww115t56p2c">
              Sales School tickets are purchased separately based on the number
              of attendees, up to a $5,000 monthly maximum.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-8 p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg max-w-3xl mx-auto" data-id="element-98" data-mp="2oz0b8o0bfbns">
        <p className="text-[#7FE0C3] text-center font-medium" data-id="element-99" data-mp="2jzx9bcfmtlk1">
          Ad spend is paid directly to the job platforms and is separate from
          HIRE&apos;s fees.
        </p>
      </div>
    </section>;
}